// Libellés du tournoi en salle.
export const PHASES = {
  waiting: 'Salle d\'attente',
  draw: 'Tirage',
  play: 'Jeu',
  count: 'Décompte',
  result: 'Résultat',
  over: 'Partie terminée',
};

export const DECISIONS = {
  ok: 'Accepté',
  avertissement: 'Avertissement',
  penalite: 'Pénalité de 5 points',
  zero: 'Zéro',
  force: 'Points imposés',
};

const REASONS = {
  vide: 'Saisie vide',
  lettres: 'Lettres absentes du tirage',
  placement: 'Placement impossible',
  incomplet: 'Mot incomplet (il touche d\'autres lettres)',
};

// Motif d'un 0 : { reason, words } du moteur
export function reasonLabel(result) {
  if (!result || !result.reason) {
    return '';
  }
  if (result.reason === 'mot') {
    return `Mot non admis : ${(result.words || []).join(', ')}`;
  }
  return REASONS[result.reason] || result.reason;
}

// 4.1 : lettres du reliquat dans l'ordre alphabétique, joker en dernier
export function sortedReliquat(reliquat) {
  return [...(reliquat || '')].sort((a, b) => (a === '?') - (b === '?') || a.localeCompare(b));
}

// Tirage en texte (4.1) : « ER? + AINLU », reliquat d'abord
export function drawLabel(reliquat, letters) {
  const kept = sortedReliquat(reliquat).join('');
  return kept ? `${kept} + ${letters}` : letters;
}

export function timeLabel(seconds) {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return rest === 0 ? `${minutes} min` : `${minutes} min ${rest} s`;
}

// « Alice », « Alice et Bruno », « Alice, Bruno et Chloé »
export function namesLabel(names) {
  if (names.length <= 1) {
    return names.join('');
  }
  return `${names.slice(0, -1).join(', ')} et ${names[names.length - 1]}`;
}
